import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import withOptions from 'utils/functions/withOptions.util';
import isNegativeNumber from 'utils/predicates/number/isNegativeNumber.util';
import isPositiveNumber from 'utils/predicates/number/isPositiveNumber.util';
import padZeroes from 'utils/strings/padZeroes.util';

const determineString = ({ is, number, pad }) => {
  if (!is.int) {
    return '';
  }

  // NOTE: according to number standard, there are two zeroes +0 and -0, and in this case it matters
  const isNegativeZero = Object.is(-0, number);

  if (!pad) {
    return isNegativeZero ? '-0' : `${number}`;
  }

  return (is.negative || isNegativeZero ? '-' : '') + padZeroes(pad, Math.abs(number));
};

const parseInteger = withOptions(({ value: raw, noNegative, pad }) => {
  // checks on raw
  const nan = Number.isNaN(raw);
  const infinite = raw === Infinity || raw === -Infinity;
  const empty = raw === '' || raw === null || raw === void 1;

  const number = fromAnyToInteger(raw);

  // checks on num
  const float = Number.isFinite(number);
  const int = Number.isSafeInteger(number);
  const negative = isNegativeNumber(number);
  const positive = isPositiveNumber(number);

  const valid = int && (noNegative ? !negative : true);
  const is = { empty, valid, nan, float, int, negative, positive, infinite };

  // eslint-disable-next-line no-nested-ternary
  const string = determineString({ is, raw, number, pad });

  return { number, string, is, raw };
});

export default parseInteger;
